import React, { useState } from 'react';
import { Box, TextField } from '@mui/material';

export function InlineEditableText({ value, placeHolder, onChange, sx, autoComplete }) {
  const [isEditing, setIsEditing] = useState(false);

  const handleBlur = () => setIsEditing(false);
  const handleKeyDown = (e) => {
    if (e.fkey === 'Enter') handleBlur();
  };

  return (
    <>
      {isEditing ? (
        <TextField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
          variant="standard"
          sx={sx}
          autoComplete={autoComplete}
          slotProps={{
            htmlInput: {
              sx: {
                fontSize: '14px',
              }
            }
          }}
        />
      ) : (
        <Box
          onClick={() => setIsEditing(true)}
          sx={{ cursor: 'pointer', ...sx }}
        >
          {value || placeHolder}
        </Box>
      )}
    </>
  );
}
